import { AuthService } from '../../../auth/AuthService'

const conversionsUrl = 'https://api.impact.com/Advertisers/IRLob3oRhLQn2060587RYcDMFhnzZ8Lre1/Conversions'

export function triggerImpactsConversionTracking(): void {
	AuthService.getAccessTokenClaims().then(claims => {
		const clickId = claims['http://globalpoker.com/pageLoadApiClickId']
		const pokId = claims['http://globalpoker.com/pok_id']
        
		if (!clickId || !pokId) return
        
		const payload = {
			campaignId: 11050,
			actionTrackerId: 20033,
			eventDate: new Date().toISOString(),
			clickId,
			customerId: pokId,
			customProfileId: pokId,
		}
		fetch(conversionsUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
		})
	})
}